import { render, staticRenderFns } from "./EditUserType.vue?vue&type=template&id=dee011fa&scoped=true"
import script from "./EditUserType.vue?vue&type=script&lang=js"
export * from "./EditUserType.vue?vue&type=script&lang=js"
import style0 from "./EditUserType.vue?vue&type=style&index=0&id=dee011fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee011fa",
  null
  
)

export default component.exports